import { SubscribeQuery } from '.';

const getAll = (
  retailerId: string, campaignId: string, page: number, pageSize: number, orderBy: string, orderDesc: boolean,
): SubscribeQuery => ({
  className: 'CampaignMessage',
  where: {
    retailer: {
      __type: 'Pointer',
      className: 'Retailer',
      objectId: retailerId,
    },
    campaign: {
      __type: 'Pointer',
      className: 'Campaign',
      objectId: campaignId,
    },
  },
  order: `${orderDesc ? '-' : ''}${orderBy}`,
  count: 1,
  limit: pageSize,
  skip: pageSize * (page - 1),
});

const getAllSent = (
  retailerId: string, campaignId: string, page: number, pageSize: number, orderBy: string, orderDesc: boolean,
): SubscribeQuery => ({
  ...getAll(retailerId, campaignId, page, pageSize, orderBy, orderDesc),
  where: {
    ...getAll(retailerId, campaignId, page, pageSize, orderBy, orderDesc).where,
    sentAt: {
      $exists: true,
    },
  },
});

const getAllRead = (
  retailerId: string, campaignId: string, page: number, pageSize: number, orderBy: string, orderDesc: boolean,
): SubscribeQuery => ({
  ...getAll(retailerId, campaignId, page, pageSize, orderBy, orderDesc),
  where: {
    ...getAll(retailerId, campaignId, page, pageSize, orderBy, orderDesc).where,
    clickedAt: {
      $exists: true,
    },
  },
});

const getAllClicked = (
  retailerId: string, campaignId: string, page: number, pageSize: number, orderBy: string, orderDesc: boolean,
): SubscribeQuery => ({
  ...getAll(retailerId, campaignId, page, pageSize, orderBy, orderDesc),
  where: {
    ...getAll(retailerId, campaignId, page, pageSize, orderBy, orderDesc).where,
    clickedAt: {
      $exists: true,
    },
  },
});

const getAllReplied = (
  retailerId: string, campaignId: string, page: number, pageSize: number, orderBy: string, orderDesc: boolean,
): SubscribeQuery => ({
  ...getAll(retailerId, campaignId, page, pageSize, orderBy, orderDesc),
  where: {
    ...getAll(retailerId, campaignId, page, pageSize, orderBy, orderDesc).where,
    repliedAt: {
      $exists: true,
    },
  },
});

const getAllFailures = (
  retailerId: string, campaignId: string, page: number, pageSize: number, orderBy: string, orderDesc: boolean,
): SubscribeQuery => ({
  ...getAll(retailerId, campaignId, page, pageSize, orderBy, orderDesc),
  where: {
    ...getAll(retailerId, campaignId, page, pageSize, orderBy, orderDesc).where,
    failedAt: {
      $exists: true,
    },
  },
});

const getAllOptOut = (
  retailerId: string, campaignId: string, page: number, pageSize: number, orderBy: string, orderDesc: boolean,
): SubscribeQuery => ({
  ...getAll(retailerId, campaignId, page, pageSize, orderBy, orderDesc),
  where: {
    ...getAll(retailerId, campaignId, page, pageSize, orderBy, orderDesc).where,
    optOut: {
      $exists: true,
    },
  },
});

const CampaignMessageQueries = {
  getAll,
  getAllSent,
  getAllRead,
  getAllClicked,
  getAllReplied,
  getAllFailures,
  getAllOptOut,
};

export default CampaignMessageQueries;
